import { RootState } from 'data/store/store';
import { Country, HomeId } from 'types';

export const NAME = 'data/INVITER';
export const LOAD_INVITER_DATA = `${NAME}/LOAD`;
export const SET_INVITER_DATA = `${NAME}/SET`;

export type RestrictionReason = 'FAILED_REVERIFICATION' | 'PLAN_HOPPED';

export type JoinRestriction = {
  reason: RestrictionReason;
  appliedUntil: string;
};

export type UserData = {
  country: Country;
  homeId: HomeId;
  isLoggedInUserMaster: boolean;
  planHoppingRestrictionsApply: boolean;
  joinRestrictions: Array<JoinRestriction>;
};

type InviterState = {
  isLoading: boolean;
  data: UserData | null;
};

type SetInviterDataAction = {
  type: typeof SET_INVITER_DATA;
  data: UserData | null;
};

type LoadInviterDataAction = {
  type: typeof LOAD_INVITER_DATA;
};

type InviterActionTypes = SetInviterDataAction | LoadInviterDataAction;

export const setInviterData = (data: UserData | null): InviterActionTypes => ({
  type: SET_INVITER_DATA,
  data,
});

export const loadInviterData = (): InviterActionTypes => ({
  type: LOAD_INVITER_DATA,
});

export const initialState: InviterState = {
  isLoading: true,
  data: null,
};

export const reducer = (
  state = initialState,
  action: InviterActionTypes,
): InviterState => {
  switch (action.type) {
    case LOAD_INVITER_DATA:
      return {
        ...state,
        isLoading: true,
      };

    case SET_INVITER_DATA:
      return {
        ...state,
        isLoading: false,
        data: (action as SetInviterDataAction).data,
      };

    default:
      return state;
  }
};

export const selector = (state: RootState) => state[NAME];
